const KEY = 'hot.brandCtx';

export const brandContext = {
  state: {
    slug: null, company_name: null,
    logo_url: null, background_url: null,
    primary: '#1528e5', secondary: '#0b0f22',
    is_active: true, share_url: null,
    phone: null, address: null
  },
  set(p){
    this.state.slug = p.slug;
    this.state.company_name = p.company_name;
    this.state.logo_url = p.logo_url;
    this.state.background_url = p.background_url;
    this.state.primary = p.primary_color || this.state.primary;
    this.state.secondary = p.secondary_color || this.state.secondary;
    this.state.is_active = !!p.is_active;
    this.state.share_url = p.share_url;
    this.state.phone = p.phone;
    this.state.address = p.address;

    localStorage.setItem(KEY, JSON.stringify(this.state));
    document.documentElement.style.setProperty('--brand-primary', this.state.primary);
    document.documentElement.style.setProperty('--brand-secondary', this.state.secondary);
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', this.state.primary);
  },
  clear(){
    localStorage.removeItem(KEY);
    this.state = { slug:null, company_name:null, logo_url:null, background_url:null,
                   primary:'#1528e5', secondary:'#0b0f22', is_active:true, share_url:null
                  , phone:null, address:null
                  };
    document.documentElement.style.removeProperty('--brand-primary');
    document.documentElement.style.removeProperty('--brand-secondary');
  },
  boot(){
    const raw = localStorage.getItem(KEY);
    if (!raw) return;
    try {
      const s = JSON.parse(raw);
      this.state = Object.assign(this.state, s);
      document.documentElement.style.setProperty('--brand-primary', this.state.primary);
      document.documentElement.style.setProperty('--brand-secondary', this.state.secondary);
    } catch {}
  }
};
